<template>
  <div>
    <TitleBar>
      <template v-slot:title><translate>Completing Setup</translate></template>
      <template v-slot:buttons>
      </template>
    </TitleBar>
    <div class="content">
      <LoadingSpinner style="z-index: 10000;" />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import TitleBar from "@/components/TitleBar"
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"

export default {
  name: "SupplierInsight",
  components: {TitleBar, LoadingSpinner},
  data() {
    return {
      customers: [],
      filters: {}
    }
  },
  created() {
    var query = this.$route.query;
    if("credentialsId" in query || "credentials_id" in query || "error" in query){

      this.addOrUpdateTinkCredential(query).then((response) => {
        this.$router.push({ name: "Bank" });
      }).catch((response)=>{
        this.$store.commit('setAlert', {
          title: this.$gettext("Failed to refresh"),
          text: response.data,
          variant: "error",
          duration: 8
        })
        this.$router.push({ name: "Bank" });
      })
    }else{
      this.$router.push({ name: "Bank" });
    }
  },
  methods: {
    ...mapActions ({
      addOrUpdateTinkCredential : "bankStore/addOrUpdateTinkCredential"
    }),
  },
  computed: {
  }
}
</script>

<style scoped>

</style>